module.exports = __webpack_public_path__ + "static/img/award5.8068df3.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/index/award5.png
// module id = J87g
// module chunks = 7